<template>
    <div class="header">
        <div class="web-main-center">
            <div class="left">
              <div class="logo" @click="handleClick({path:'/'},-1)"><img :src="appLogin" class="imgW" alt=""></div>
              <ul class="nav-list">
                <li v-for="(item,index) in navList" :key="index" :class="{active:activIdx==item.id}" @click="handleClick(item)">
                    {{t(item.langname)}}
                </li>
              </ul>
            </div>
            <div class="right">
              <div class="lang-btn">
                <span @click="handleOpenLange"><img src="@/assets/img/header/yuyan.png" alt="" class="imgW"></span>
                <ul class="lang-list" v-if="isShowLangSelect">
                  <li v-for="(item,index) in langList" :key="index" :class="{active:currentLang==item.slug}" @click="changeLang(item)">
                    {{ item.name }}
                  </li>
                </ul>
              </div>
              <div class="app-btn" @click="download">{{t('downloadApp')}}</div>
            </div>
        </div>
    </div>
  </template>

  <script >
  export default {
    name: 'WebHeader',
  }
  </script>
  <script setup >
  import { ref,onMounted,computed } from "vue";
  import { useRouter } from 'vue-router';
  import { navList } from '@/hooks/mock';
  import { useI18n } from "vue-i18n";  // 引用组件
  import { useStore } from 'vuex'
  const {  locale,t } = useI18n();  // 解构调用函数
  const store = useStore()
  // 获取语言列表
  const  langList = computed(() => store.state.languages)
  const  downloadUrl = computed(() => store.state.download)
  //获取logo
  const  appLogin = computed(() => store.state.appLogin)
    // 切换导航
    const activIdx = ref('');
    const router = useRouter();
    const handleClick = (item, i) => {
      router.push({ path: item.path });
      activIdx.value = item.id;
    };
    // 切换语言
    const currentLang = ref('')
    const isShowLangSelect = ref(false)
    currentLang.value = locale.value
    // 切换语言item
    const changeLang = (item)=>{
      currentLang.value = item.slug
      isShowLangSelect.value = false
      locale.value = item.slug
      store.commit('setLanguagesCode', item.slug)
      localStorage.setItem('lang',item.slug)
    }
    // 打开语言选择
    const handleOpenLange = ()=>{
      isShowLangSelect.value = true
    }

    const download = () =>{
      let browser = {
            versions: function() {
                var u = navigator.userAgent, app = navigator.appVersion;
                return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
                iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
                };
            }(),
                language: (navigator.browserLanguage || navigator.language).toLowerCase()
        }

        if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
            //判断是IOS后跳转到相应的链接
            window.location.href = downloadUrl.value.ios
        }else if (browser.versions.android) {
           //判断是android后跳转到相应的链接
            window.open(downloadUrl.value.android)
        }
    }

    onMounted(() => {
      const url = location.href;
      const currPath = url.split('#')[1];
      const idx = navList.findIndex((item) => {
        return item.path === currPath;
      });
      if (idx !== -1) activIdx.value = idx;
    });

  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="less" scoped >
  .header{
    margin-top: 15px;
      .web-main-center{
        display:flex;
        justify-content: space-between;
        .left{
          display: flex;
          align-items: center;
        }
        .logo{
          // display: inline-block;
          // float: left;
          width: 127px;
          // vertical-align: middle;
          // margin-top: -2px;
          cursor: pointer;
          img{
            display: block;
          }
        }
      }
      .nav-list{
        display: flex;
        justify-content: space-around;
        width: 800px;
        margin-top: 2px;
        li{
          display: inline-block;
          font-size: 14px;
          // margin-left: 64px;
          vertical-align: middle;
          padding: 10px;
          cursor: pointer;
          &:hover{
            color: var(--base-keynote-color);
          }
          &.active{
            border-bottom: 2px solid var(--base-keynote-color);
          }
        }
      }
      .right{
        text-align: right;
        display: flex;
        align-items: center;
        .lang-btn{
          display: inline-block;
          margin-top: -2px;
          vertical-align: middle;
          position: relative;
          span{
            width: 24px;
            display: inline-block;
            cursor: pointer;
          }
        }
        .lang-list{
          position: absolute;
          right: -10px;
          top: 100%;
          z-index: 200;
          background-color: var(--black-box-bg);
          width: 126px;
          height: 200px;
          font-size: 12px;
          text-align: left;
          li{
            padding: 10px;
            cursor: pointer;
            &.active{
              color: var(--base-keynote-color);
            }
          }
        }
        .app-btn{
          display: inline-block;
          font-size: 14px;
          padding: 0 10px;
          height: 30px;
          background: var(--base-keynote-color);
          border-radius: 8px;
          vertical-align: middle;
          text-align: center;
          line-height: 30px;
          color: var(--black-color);
          cursor: pointer;
          margin-left: 20px;
        }
      }
  }
  </style>
